import * as Sentry from '@sentry/browser';

import React from "react";
import PropTypes from "prop-types";

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: null, errorInfo: null };
    }

    componentDidCatch(error, errorInfo) {
        // Configure error info and capture exception to sentry
        Sentry.configureScope(scope => {
            scope.setExtra('react_boundary_info', errorInfo);
        });

        Sentry.captureException(error);
        // Catch errors in any components below and re-render with error message
        this.setState({
            error: error,
            errorInfo: errorInfo
        })
        // You can also log error messages to an error reporting service here
    }

    renderDev() {
        return (
            <div className="error-boundary-container">
                <h2><span role="img" aria-label="Revolving light emoji">🚨</span> Something went wrong.</h2>
                <details style={{ whiteSpace: 'pre-wrap' }}>
                    {this.state.error && this.state.error.toString()}
                    <br />
                    {this.state.errorInfo.componentStack}
                </details>
            </div>
        );
    }

    render() {
        if (this.state.errorInfo) {
            if (process.env.NODE_ENV === "production") {
                return this.props.children;
            } else {
                return this.renderDev();
            }
        }
        // Normally, just render children
        return this.props.children;
    }
}

ErrorBoundary.propTypes = {
    children: PropTypes.node
};